module.exports = __webpack_public_path__ + "img/ocean.4cf2495c.svg";